<template>
    <div v-if="isOpenedSettings" class="modal is-active">
        <div class="modal-background" @click="toggleSettings"></div>
        <div class="modal-card w-70">
            <header class="modal-card-head">
                <p class="modal-card-title">{{ $t("settings.settings") }}</p>
                <button class="delete" @click="toggleSettings"></button>
            </header>
            <section class="modal-card-body">
                <BehindTheScene
                    ref="BehindScene"
                    roomId="invalidId"
                    :isPreviousRoom="false"
                />
            </section>
            <footer class="modal-card-foot">
                <button class="button is-primary" @click="changeSettings">
                    {{ $t("settings.save") }}
                </button>
            </footer>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import BehindTheScene from "@/components/conference/BehindTheScene.vue";

export default {
    components: { BehindTheScene },
    name: "settings",
    computed: {
        ...mapGetters("conference", [
            "isOpenedSettings",
            "getMediaStreamConstraints",
        ]),
    },
    methods: {
        ...mapActions("conference", [
            "toggleSettings",
            "setMediaStreamConstraints",
        ]),
        changeSettings() {
            let mediaConstraints = this.$refs.BehindScene.getStreamConstraints();
            let actualMediaConstraints = this.getMediaStreamConstraints;

            let changed = this.haveChangedSettings(
                mediaConstraints,
                actualMediaConstraints
            );

            // If changed something from actual settings
            if (changed) {
                this.setMediaStreamConstraints({
                    mediaStreamConstraints: mediaConstraints,
                });
            }

            this.$emit("save");
        },
        haveChangedSettings(newMediaConstraints, oldMediaConstraints) {
            let newSettings = JSON.stringify(newMediaConstraints);
            let oldSettings = JSON.stringify(oldMediaConstraints);
            return newSettings !== oldSettings;
        },
    },
};
</script>

<style lang="scss" scoped>
.w-70 {
    width: 70vw;
}
</style>